<template>
  <div class="action-button-group" :class="{ 'action-button-group--compact': compact }">
    <v-tooltip
      v-for="action in visibleActions"
      :key="action.key"
      bottom
      :disabled="!action.tooltip"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          :color="action.color || 'primary'"
          :icon="action.iconOnly"
          :fab="action.fab && !action.iconOnly"
          :small="small || action.small"
          :outlined="action.outlined"
          :text="action.text"
          :disabled="action.disabled || loading"
          :loading="action.loading"
          @click="handleAction(action)"
          class="action-btn"
          :class="{ 'action-btn--icon-only': action.iconOnly }"
        >
          <v-icon :left="!action.iconOnly && action.icon">
            {{ action.icon }}
          </v-icon>
          <span v-if="!action.iconOnly">{{ action.label }}</span>
        </v-btn>
      </template>
      <span>{{ action.tooltip || action.label }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "ActionButtonGroup",
  props: {
    actions: {
      type: Array,
      required: true,
      // Expected format:
      // [{
      //   key: 'add',
      //   label: 'Add User',
      //   icon: 'mdi-plus',
      //   color: 'primary',
      //   iconOnly: false,
      //   outlined: false,
      //   text: false,
      //   small: false,
      //   fab: false,
      //   disabled: false,
      //   loading: false,
      //   tooltip: 'Add new user',
      //   hidden: false
      // }]
    },
    small: {
      type: Boolean,
      default: false,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    visibleActions() {
      return this.actions.filter((action) => !action.hidden);
    },
  },
  methods: {
    handleAction(action) {
      if (action.disabled || this.loading) return;
      this.$emit("action", action.key, action);
    },
  },
};
</script>

<style scoped>
.action-button-group {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px;
  background: #f6f8fa;
  border-radius: 8px;
  flex-wrap: wrap;
}

.action-button-group--compact {
  gap: 4px;
  padding: 2px;
}

.action-btn {
  transition: all 0.2s ease;
  text-transform: none;
  letter-spacing: 0.25px;
}

.action-btn:not(.action-btn--icon-only) {
  padding: 0 16px;
}

.action-btn--icon-only {
  min-width: 40px !important;
  width: 40px;
  height: 40px;
}

.action-button-group--compact .action-btn--icon-only {
  min-width: 36px !important;
  width: 36px;
  height: 36px;
}

.action-btn:hover {
  transform: translateY(-1px);
}

.action-btn:active {
  transform: translateY(0);
}

/* Responsive */
@media (max-width: 600px) {
  .action-button-group {
    gap: 4px;
  }

  .action-btn:not(.action-btn--icon-only) >>> .v-btn__content span {
    display: none;
  }

  .action-btn:not(.action-btn--icon-only) {
    min-width: 40px !important;
    width: 40px;
    padding: 0;
  }

  .action-btn >>> .v-icon {
    margin: 0 !important;
  }
}
</style>
